import React, { useMemo, useState } from "react";
import * as S from "./RpmList.style";
import { useTranslation } from "react-i18next";
import FollowUpBox from "../followUpBox/FollowUpBox";
import { useQuery, useSubscription } from "@apollo/client";
import { useStateValue } from "../../../../../../../contextAPI/StateProvider";
import { SUBSCRIPTION_GET_USER_TO_PROCESS_BY_ISACEPTED } from "../../../../../../../graphql/subscriptions/UserToProcess";
import ZaiaReaction from "../../../../../../zaiaComponents/zaiaReaction";
import useRecordNavigation from "../../../../../../../hooks/useRecordNavigation";
import { Actions } from "../../../../../../../utils/actionsIds";
import useAssignSelectPatient from "../../../../../../../hooks/useAssignSelectPatient";
import { QUERY_GET_USERS_WITH_RPM_CONTENT } from "../../../../../../../graphql/queries/User";
import RpmBox from "../rpmBox/RpmBox";


const logoZaiaEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function RpmList({
  inputText,
  textInput,
  setInputText
}) {

  const {t, i18n: { language }} = useTranslation("global");
  const [, dispatch] = useStateValue();
  const { recordAction } = useRecordNavigation();
  const { selectPatient } = useAssignSelectPatient();
  
  // calculate the initial date of the current month
  const initialDateOfMonth = useMemo(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  }, []);
  
  

  const { data: userWithRmp, error: userWithRmpError, loading: userWithRmpLoading } = useQuery(QUERY_GET_USERS_WITH_RPM_CONTENT, {
    variables: { 
      dateMonthAgo: initialDateOfMonth
     }
  });

  const stages = [
    {
      id: 0,
      key: "all",
      name: t("globally.all"),
      color: "#1F1F52"
    },
    {
      id: 1,
      key: "less",
      name: t("aiNavigator.rpm.less20Minutes"),
      color: "#1F1F52"
    },
    {
      id: 2,
      key: "more",
      name: t("aiNavigator.rpm.more20Minutes"),
      color: "#1F1F52"
    }
  ]

  const getCallMinutes = (user) => {
    if (!user?.userToProcesses) return 0;

    return user.userToProcesses.reduce((total, process) => {
      if (!process.userToProcessHistories) return total;

      const subtotal = process.userToProcessHistories.reduce((sum, history) => {
        const duration = parseFloat(history?.call?.duration || 0);
        return sum + (isNaN(duration) ? 0 : duration);
      }, 0);

      return total + subtotal;
    }, 0);
  }

  const getRMPReports = (user) => {
    if (!user?.userToDevices) return 0;

    return user.userToDevices.reduce((total, device) => {
      if (!device.userVitalSignHistories) return total;

      const subtotal = device.userVitalSignHistories.length || 0;

      return total + subtotal;
    }, 0);
    
  }


  const [selectedState, setSelectedState ] = useState(stages[0]);

  // const followUpInfo = useMemo(() => {
  //   return userToProcesses?.userToProcess
  //   .filter(userToProcess => userToProcess?.processStage?.id !== "enroll")
  //   .sort((a, b) => new Date(a.nextUpdate) - new Date(b.nextUpdate))
  //   .map((userToProcess, index) => {
  //     return (userToProcess)
  //   })
  // }, [userToProcesses]);

  const setFollowUpActive = (userToProcess) => {
    dispatch({
      type: "SET_FOLLOWUP_ACTIVE",
      followUpActive: userToProcess,
    });
    dispatch({
      type: "SET_FOLLOWUP_MINIMIZED",
      followUpMinimized: false,
    });
  }

  const selectFollowUpPatient = (user) => {
    recordAction(Actions.AINAVIGATOR.SELECT_FOLLOW_UP_PATIENT);
    setFollowUpActive(user.userToProcesses[0]);
    selectPatient(user.id)
  }

  const getFilterText = (text) => {
    return inputText 
      ? String(text).toLowerCase().includes(inputText.toLowerCase())
      : true
  }    
  
  return (
    <S.RpmList>
      <div className="header">
        <div className="filter-state">
          {
            stages.map((state, index) => {
              return (
                <div
                  key={state.id}
                  onClick={() => setSelectedState(state)}
                >
                  <S.TabItem
                    activeTab={selectedState.id === state.id}
                    key={index}
                    color={state.color}
                  > 
                    <div className="item-text">
                      {
                        `
                          ${state.name}
                        `
                      }
                    </div>
                    { 
                      state.id !== 0 &&
                      <div className="item-point"></div>
                    }
                  </S.TabItem>
                </div>
              )
            })
  
          }
        </div>
        <div className="filters-button"
          style={{visibility: "hidden"}}
        >
          <i className="filters-button__icon icon zaia-menu"></i>
          <div className="filters-button__text">{t("globally.filterBy")}</div>
        </div>
      </div>

      <S.ButtonsContainer>
        <div className="buttons-container__caption">
          {
            inputText && (
            <div className="caption">
                <div className="caption__text">
                  {t("globally.resultsFor")}
                  <div>
                    <i
                      className="icon zaia-icono-cerrar"
                      onClick={() => {
                        setInputText("")
                        textInput.set = ""
                      }}
                    />
                    {inputText}
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </S.ButtonsContainer>

      <div className="follow-up-list">
        <div className="follow-up-list__center">
          {
            userWithRmp?.user.filter((item) => getFilterText(`${item.name} ${item.lastname}`) || getFilterText(item.email))?.map((user, index) => {

              if(
                (selectedState.id === 1 && getCallMinutes(user) < 1200) ||
                (selectedState.id === 2 && getCallMinutes(user) >= 1200) ||
                (selectedState.id === 0)
              )
                return (
                  <div className="follow-up__item" 
                    key={user.id}
                    onClick={() => 
                      selectFollowUpPatient(user)
                    }
                  >
                    <RpmBox
                      key={user.id}
                      user={user}
                      callMinutes={getCallMinutes(user)}
                      rpmReports={getRMPReports(user)}
                    />
                  </div>
                )
            })
          }
          {
            userWithRmp?.user.length === 0 && 
              <ZaiaReaction
                zaiaImg={logoZaiaEmpty}
                text={t("globally.noResults")}
                subText={t("globally.noMatchingPatients")}
                sizeText="33.25px"
                sizeSubText="15px"
                textColor="var(--blue-color)"
                widthimg="210px"
              />
          }
          {
            userWithRmpError &&
              <ZaiaReaction
                zaiaImg={logoZaiaAlert}
                sizeText="20px"
                text={t("globally.genericError")}
                textColor="var(--blue-color)"
                widthimg="150px"
              />
          }
          {
            userWithRmpLoading &&
              <ZaiaReaction
                zaiaImg={logoZaiaLoading}
                sizeText="20px"
                textColor="var(--blue-color)"
                widthimg="150px"
              />
          }
        </div>

        <div className="follow-up-list__bottom">
          {/* <div className="pagination">
            <i className="pagination__arrow pagination__arrow--back icon zaia-icono-atras"></i>
            <div className="pagination__number pagination__number--selected">1</div>
            <div className="pagination__number">2</div>
            <div className="pagination__number">3</div>
            <div className="pagination__number">4</div>
            <div className="pagination__number">5</div>
            <i className="pagination__arrow pagination__arrow--next icon zaia-i-next"></i>
          </div> */}

          {/* <div className="add-patient">
            <div className="add-patient__text">Add patient</div>
            <i className="add-patient__icon icon zaia-i-invitepatient"></i>
          </div> */}
        </div>
      </div>
    </S.RpmList>
  );
}

export default RpmList;
